// src/Components/CustomerAccount.styles.js
export const COLORS = {
  primary: '#8A9A7B',
  primaryLight: '#9EAD8C',
  primaryDark: '#6A7A5B',
  primaryBg: '#F0F4EB',
  accent: '#6C5B7B',
  accentLight: '#8A7B9B',
  warm: '#E8A87C',
  warmLight: '#F5D4B8',
  danger: '#D4837A',
  success: '#7A9B8A',
  text: '#3D4A33',
  textLight: '#8A9A7B',
  border: '#DCE4D3',
  cardBg: '#FAFCF8',
};